import {Injectable} from '@angular/core';
// import LatLng = google.maps.LatLng;
// import MapTypeStyle = google.maps.MapTypeStyle;
// import MapOptions = google.maps.MapOptions;
// import AutocompleteOptions = google.maps.places.AutocompleteOptions;

@Injectable()
export class GoogleProviderService {
  constructor() {
  }

  /******************************************** GOOGLE ***************************************************/
  public static readonly key = 'AIzaSyCIsged6jYqqstSeO4nM79Wzk7seiaHFi4';
  private static readonly url = 'https://maps.googleapis.com/maps/api/js?callback=__onGoogleMapsLoaded&libraries=places&key=' + GoogleProviderService.key;

  private static googleMapsPromise;
  public static async load() {
    // First time 'load' is called?
    if (!GoogleProviderService.googleMapsPromise) {

      // Make promise to load
      GoogleProviderService.googleMapsPromise = new Promise((resolve) => {

        // Set callback for when google maps is loaded.
        window['__onGoogleMapsLoaded'] = (ev) => {
          console.log('google maps api loaded');
          resolve(window['google']['maps']);
        };

        // Add script tag to load google maps, which then triggers the callback, which resolves the promise with windows.google.maps.
        console.log('loading..');
        const node = document.createElement('script');
        node.src = GoogleProviderService.url;
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
      });
    }

    // Always return promise. When 'load' is called many times, the promise is already resolved.
    return GoogleProviderService.googleMapsPromise;
  }

  // // public getOverlay(): google.maps.OverlayView {
  //   // return new google.maps.OverlayView();
  // }

  // // public getLatLng(lat: number, lng: number, noWrap?: boolean): google.maps.LatLng {
  //   // return new google.maps.LatLng(lat, lng, noWrap);
  // }

  // // public getMap(elem: HTMLElement, mapOptions: MapOptions): google.maps.Map {
  //   // return new google.maps.Map(elem, mapOptions);
  // }

  // // public getMapStyleType(style: MapTypeStyle[], name: { name: string }): google.maps.StyledMapType {
  //   // return new google.maps.StyledMapType(style, name);
  // }

  // // public getGoogleGeocoder(): google.maps.Geocoder {
  //   // return new google.maps.Geocoder();
  // }

  // // public getAutocompleteService(): google.maps.places.AutocompleteService {
  //   // return new google.maps.places.AutocompleteService();
  // }

  // // public getAutocomplete(input: HTMLInputElement, options: AutocompleteOptions): google.maps.places.Autocomplete {
  //   // return new google.maps.places.Autocomplete(input, options);
  // }

  // // public getInfoWindow(): google.maps.InfoWindow {
  //   // return new google.maps.InfoWindow();
  // }

  // // public getMarker(place: { position: LatLng, map: any }): google.maps.Marker {
  //   // return new google.maps.Marker(place);
  // }

  // // public getPoint(x: number, y: number): google.maps.Point {
  //   // return new google.maps.Point(x, y);
  // }

  // // public getDirectionsService(): google.maps.DirectionsService {
  //   // return new google.maps.DirectionsService();
  // }

  // // public getDirectionsRenderer(): google.maps.DirectionsRenderer {
  //   // return new google.maps.DirectionsRenderer;
  // }

  public getChartWrapper(): google.visualization.ChartWrapper {
    return new google.visualization.ChartWrapper();
  }

  public getVisualizationEvents() {
    return google.visualization.events;
  }

  public getArrayToDataTable() {
    return google.visualization.arrayToDataTable;
  }

  // public getAutocompleteBounds() {
  //   // return new google.maps.LatLngBounds(
  //     // new google.maps.LatLng(55, 19),
  //     // new google.maps.LatLng(70, 30));
  // }
}
